// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k0-1";
export var stateContainer = "_k0-0";